// extracted by mini-css-extract-plugin
module.exports = {"wrap":"section-redot-module--wrap--3nVHf","gif":"section-redot-module--gif--27XiW","boxdot":"section-redot-module--boxdot--2vBID","dot":"section-redot-module--dot--1ez6m"};